<script>
import { MASTER } from "@/assets/JS/Master.js";

export default {
    name: "Footer",
    data: () => ({ MASTER })
};
</script>

<template>
    <div id="footer">
        <div class="row">
            <div class="m-pad m-rows">
                <div class="base icons margin-l m-align-c">
                    <a href="#" target="_blank" @click="MASTER.PromptLeavingPage('https://www.facebook.com/LACountyRRCC/');"><img title="Facebook" alt="Icon - Facebook" src="@/assets/Images/Template/IconFacebook.png"/></a>
                    <a href="#" target="_blank" @click="MASTER.PromptLeavingPage('https://twitter.com/lacountyrrcc');"><img title="Twitter" alt="Icon - Twitter" src="@/assets/Images/Template/IconTwitter.png"/></a>
                    <a href="#" target="_blank" @click="MASTER.PromptLeavingPage('https://instagram.com/lacountyrrcc');"><img title="Instagram" alt="Icon - Instagram" src="@/assets/Images/Template/IconInstagram.png"/></a>
                    <a href="#" target="_blank" @click="MASTER.PromptLeavingPage('https://www.yelp.com/biz/los-angeles-county-registrar-recorder-county-clerk-norwalk');"><img title="Yelp" alt="Icon - Yelp" src="@/assets/Images/Template/IconYelp.png"/></a>
                    <a href="#" target="_blank" @click="MASTER.PromptLeavingPage('https://www.youtube.com/user/lacountyrrcc');"><img title="YouTube" alt="Icon - YouTube" src="@/assets/Images/Template/IconYoutube.png"/></a>
                </div>
                <div class="landscape m-margin-align-c right">
                    <a class="base button-contact" href="https://www.lavote.net/contact-us/contact-us" target="_blank">
                        <div class="base">
                            <img src="@/assets/Images/Template/IconCallUs.png" alt="Icon - Call Us" title="Call Us" width="30" height="30"/>
                        </div>
                        <div class="base label">
                            <span>Contact Us</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>